export const DashboardVi = {

    dashboard: {
        menu: {
            label: {
                all: "ALL APPS",
                work: "WORK+",
                hrm: "HRM+",
                other: "OTHER+"
            }
        },
        service: {
            label: {
                doWork: "doWork",
                doFolder: "doFolder",
                doHrm: "doHrm",
                doMe: "doMe",
                doCalendar: "doCalendar",
                doDocument: "doDocument",
                doAsset: "doAsset",
                doAssignment: "doAssignment",
                doTimekeeping: "doTimekeeping",
                doApplication: "doApplication",
                doCms: "doCms"
            },
            description: {
                doWork: "Quản lý công việc, dự án",
                doFolder: "Quản lý tài liệu",
                doHrm: "Quản lý nguồn nhân lực",
                doMe: "Thông tin nhân viên",
                doCalendar: "Quản lý lịch biểu",
                doDocument: "Quản lý công văn",
                doAsset: "Quản lý tài sản",
                doAssignment: "Đánh giá",
                doTimekeeping: "Chấm công",
                doApplication: "Quản lý đơn từ",
                doCms: "Quản lý nội dung",
                doDynamicForm: "Biểu mẫu động",
                doWorkflow: "Quy trình động"
            }
        }
    }
}